import React from 'react'
import { Form, Input } from 'antd'

export const NotificationEmailForm = ({ form }) => {
  // const [form] = Form.useForm()

  return (
    <Form form={form} layout="vertical" name="form_in_modal">
      <Form.Item
        name="email"
        label="Email"
        rules={[{ required: true, type: 'email' }]}
      >
        <Input />
      </Form.Item>
    </Form>
  )
}
